import { CommentField } from "@/shared/components/comment-field/comment-field";
import { IconButton } from "@spz/ui/components/button";
import { useResultDetailActivityFormModel } from "../hooks/use-resul-detail-activity-form";

type ResultDetailActivityFormProps = {
  controlId: string;
  controlResultId: string;
  companyId: string;
};

export const ResultDetailActivityForm = ({
  controlId,
  controlResultId,
  companyId,
}: ResultDetailActivityFormProps) => {
  const { form, attachmentForm, commentFieldRef, handleSubmit } =
    useResultDetailActivityFormModel(controlId, controlResultId, companyId);

  return (
    <CommentField
      ref={commentFieldRef}
      companyId={companyId}
      allowedFileTypes={attachmentForm.allowedFileTypes}
      onChange={form.update}
      submitBtn={
        <IconButton
          type="button"
          icon="send-horizontal"
          onClick={handleSubmit}
          disabled={!form.valid}
        />
      }
    />
  );
};
